const transformToAssocArray = function transformToAssocArray(prmstr) {
  const params = {};
  const prmarr = prmstr.split('&');

  for (let i = 0; i < prmarr.length; i++) {
    const tmparr = prmarr[i].split('=');
    params[tmparr[0]] = tmparr[1];
  }

  return params;
};

const getParams = function getParams() {
  const prmstr = window.location.search.substr(1);
  return prmstr !== null && prmstr !== '' ? transformToAssocArray(prmstr) : {};
};

const checkBrowser = function checkBrowser() {
  /*
    Returns what browser this is
  */
  const isiPad = navigator.userAgent.match(/iPad/i) !== null;
  const isiPhone = navigator.userAgent.match(/iPhone|iPod/i) !== null;
  const isChrome = navigator.userAgent.match(/chrome/i) !== null;
  const isSafari = (navigator.userAgent.match(/Safari/i) !== null) && !isChrome;
  const isAndroid = navigator.userAgent.match(/Android/i) !== null;
  const isIE = (navigator.appName === 'Microsoft Internet Explorer');
  const ua = window.navigator.userAgent;
  const ie = ua.indexOf('MSIE ');
  // var isFF = $.browser.mozilla
  if (isiPad) {
    return 'ipad';
  } else if (isiPhone) {
    return 'iphone';
  } else if (isAndroid) {
    return 'android';
  } else if (isChrome) {
    return 'chrome';
  } else if (isSafari) {
    return 'safari';
  } else if (isIE) {
    return 'ie' + parseInt(ua.substring(ie + 5, ua.indexOf('.', ie)), 10);
  } else {
    return 'ff';
  }
};

const getParentUrl = function getParentUrl() {
  const isInIframe = (parent !== window);
  let parentUrl = null;

  if (isInIframe) {
    parentUrl = document.referrer;
  }

  return parentUrl;
};

const AcHelper = {
  transformToAssocArray,
  getParams,
  checkBrowser,
  getParentUrl,
};

export default AcHelper;
